import { t } from '@if/core/i18n'
import * as yup from '@if/core/yup'

export const MIN_LOAN_AMOUNT = 500

export const customBuydownSchema = yup.object({
  contribution: yup.number().required().min(0.005).max(0.2),
  activeFrom: yup.dateOnly().required(),
  expiresOn: yup.dateOnly().defined().nullable().min(yup.ref('activeFrom')),
 
  maxFinancingAmount: yup
    .number()
    .min(MIN_LOAN_AMOUNT, () => t('customBuydown.errors.maxFinancingAmountMin', { min: MIN_LOAN_AMOUNT }))
    .defined()
    .nullable(),
})

export type CustomBuydownFormValues = yup.InferType<typeof customBuydownSchema>
